import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import { useNotificationContext } from '../../context'
import { useCopyToClipboard } from '../../hooks/use-copy-to-clipboard'
import { AnimatedCopyIcon } from '../motion'

const CopyIcon = (props) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    fill='none'
    viewBox='0 0 24 24'
    stroke='currentColor'
    {...props}
  >
    <path
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth={2}
      d='M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z'
    />
  </svg>
)

const ApiKey = ({ apiKey, deleteApiKey }) => {
  const { t } = useTranslation()
  const { error } = useNotificationContext()
  const { copied, copy } = useCopyToClipboard({ resetAfter: 1000 * 3 })

  const copyApiKeyToClipboard = async () => {
    if (!(await copy(apiKey))) error(t('global.copy_error'))
  }

  return (
    <div className='rounded-md bg-white px-6 py-5'>
      <div className='flex items-center'>
        <div>
          <svg
            xmlns='http://www.w3.org/2000/svg'
            className='h-6 w-6'
            fill='none'
            viewBox='0 0 24 24'
            stroke='currentColor'
          >
            <path
              strokeLinecap='round'
              strokeLinejoin='round'
              strokeWidth={2}
              d='M10 20l4-16m4 4l4 4-4 4M6 16l-4-4 4-4'
            />
          </svg>
        </div>
        <div className='mx-4 truncate text-sm text-gray-700'>{apiKey}</div>
        <button
          type='button'
          aria-label={t('global.copy_action')}
          title={t('global.copy_action')}
          className='ml-auto cursor-pointer rounded focus-visible:outline focus-visible:outline-2 focus-visible:outline-blue-600'
          onClick={copyApiKeyToClipboard}
        >
          <AnimatedCopyIcon
            copied={copied}
            icon={CopyIcon}
            className='size-6 text-[#1b5e20]'
            checkClassName='text-[#1b5e20]'
          />
        </button>
        <div className='ml-2 cursor-pointer' onClick={deleteApiKey}>
          <svg
            xmlns='http://www.w3.org/2000/svg'
            className='h-6 w-6'
            fill='none'
            viewBox='0 0 24 24'
            stroke='#b71c1c'
          >
            <path
              strokeLinecap='round'
              strokeLinejoin='round'
              strokeWidth={2}
              d='M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16'
            />
          </svg>
        </div>
      </div>
    </div>
  )
}

ApiKey.propTypes = {
  apiKey: PropTypes.string.isRequired,
  deleteApiKey: PropTypes.func.isRequired
}

export default ApiKey
